// banner s citaty
(function($) {
  $.fn.quotationBlock = function(opts) {
    $.getJSON(opts.url)
  	.then(data => {
      let defaultOpts = {
        lang: 'cz',
        ms: 8000,
        fadeMs: 300,
        timeChange: true
      }
      let customOpts = opts || {}
      opts = Object.assign(defaultOpts, customOpts)

      let prevIndex, currentIndex
      let itemRank
      let currentItem
      let list = data[opts.lang]
      let listLength = data[opts.lang].length

      if(list.length === 0)
        return

      let block = $(`
        <cite class="show-quote">
          <span class="quote-text"></span>
          <span class="quote-author"></span>
        </cite>
        `).appendTo($(this))

        let authorBlock = $(this).find('.quote-author')
        let quoteTextBlock = $(this).find('.quote-text')

        itemRank = getRandomNb(0, listLength)
        setQuote(itemRank)
        writeQuote(currentItem)

        // zde je blok ktery probehne jen pokud se ma text menit v case
        if(opts.timeChange && list.length > 1)
          changeQuoteByInterval(list, opts.ms)

        function getRandomNb(min, max) {
          if(typeof prevIndex === 'undefined') {
            prevIndex = Math.floor(Math.random() * (max - min) + min)
              return prevIndex
          }
          else {
            let currentIndex = Math.floor(Math.random() * (max - min) + min)
            if(currentIndex === prevIndex)
              return getRandomNb(min, max)
            else {
              prevIndex = currentIndex
              return currentIndex
            }
          }
        }

        function setQuote(rank) {
          currentItem = list[rank]
        }

        function writeQuote(quote) {
          authorBlock.text(quote.author)
          quoteTextBlock.text(quote.text)
        }

        function animateQuote(quote) {
          $('.show-quote').fadeOut(opts.fadeMs, function() {
            writeQuote(quote)
            $('.show-quote').fadeIn(opts.fadeMs)
          })
        }

        function changeQuoteByInterval(list, ms) {
          if(list.length <=1)
            return

          let timer = setInterval(() => {
            itemRank = getRandomNb(0, listLength)
            setQuote(itemRank)
            animateQuote(currentItem)
          }, ms)
        }

  	})
  	.fail(err => {
  		console.error('Error loading data', err)
  	})
  }
}(jQuery))
